<template>
  <LoginCard :header="header">
    <h2 :class="$style.subheader">
      {{ subheader }}
    </h2>

    <p :class="$style.error">
      {{ error }}
    </p>

    <LoginActionButton
      :action="buttonProps.action"
    >
      {{ buttonProps.text }}
    </LoginActionButton>
  </LoginCard>
</template>

<script>
import LoginActionButton from 'client/components/LoginActionButton.vue';
import LoginCard from 'client/components/LoginCard.vue';

export default {
  name: 'ChooseMfaError',

  components: {
    LoginActionButton,
    LoginCard,
  },

  props: {
    buttonProps: {
      type: Object,
      default: () => ({
        action: () => {},
        text: '',
      }),
    },
    error: {
      type: String,
      default: '',
    },
    header: {
      type: String,
      default: '',
    },
    subheader: {
      type: String,
      default: '',
    },
  },
};
</script>

<style module>
@value (jcGrey800, jcGrey900, jcError100) from 'css/brand-colors.css';

.subheader {
  color: jcGrey800;
  font-size: 0.75rem;
  font-weight: 600;
  margin: 1.5rem 0 2rem 0;
}

.error {
  background-color: jcError100;
  border-radius: 3px;
  color: jcGrey900;
  font-size: 0.75rem;
  font-weight: 600;
  margin: 0;
  padding: 1rem;
  text-align: left;
}
</style>
